// RFC-0008 T4: 前端 API 客户端
// 调用同源 Pages Functions（/api/...）

export interface DeckMeta {
  deck_id: string;
  title: string;
  template: string;
  page_count: number;
  file_url: string;
  thumbnail_url: string | null;
  cover_svg: string | null;
  created_at: string;
  updated_at: string;
}

export interface DeckPage {
  index: number;
  svg: string;
  title: string | null;
}

export interface DeckDetail extends DeckMeta {
  pages: DeckPage[];
}

const API_BASE = (typeof window !== 'undefined' && (window as any).__NORTH_DECKS_API_BASE) || '';

async function fetchJson<T>(input: string, init?: RequestInit): Promise<T> {
  const res = await fetch(API_BASE + input, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers || {}),
    },
  });
  if (!res.ok) {
    let msg = `${res.status} ${res.statusText}`;
    try {
      const body = await res.json();
      if (body && typeof body === 'object' && 'error' in body) msg = String(body.error);
    } catch {
      // ignore parse error
    }
    throw new Error(msg);
  }
  return (await res.json()) as T;
}

// ─── User binding ────────────────────────────────────────

export interface UserCheckResult {
  app_user_id?: string;
  exists: boolean;
  is_new?: boolean;
}

export function checkUser(host_user_id: string): Promise<UserCheckResult> {
  return fetchJson<UserCheckResult>('/api/user', {
    method: 'POST',
    body: JSON.stringify({ action: 'check', host_user_id }),
  });
}

export function registerUser(host_user_id: string): Promise<UserCheckResult> {
  return fetchJson<UserCheckResult>('/api/user', {
    method: 'POST',
    body: JSON.stringify({ action: 'register', host_user_id }),
  });
}

// ─── Decks ───────────────────────────────────────────────

export interface ListDecksResult {
  data: DeckMeta[];
}

export function listDecks(user_id: string): Promise<ListDecksResult> {
  return fetchJson<ListDecksResult>(`/api/decks?user_id=${encodeURIComponent(user_id)}`);
}

export function getDeck(user_id: string, deck_id: string): Promise<DeckDetail> {
  return fetchJson<DeckDetail>(
    `/api/decks/${encodeURIComponent(deck_id)}?user_id=${encodeURIComponent(user_id)}`,
  );
}

export function deleteDeck(user_id: string, deck_id: string): Promise<{ ok: true }> {
  return fetchJson<{ ok: true }>(
    `/api/decks?user_id=${encodeURIComponent(user_id)}&deck_id=${encodeURIComponent(deck_id)}`,
    { method: 'DELETE' },
  );
}

// 文件直链（注意走 /api/files 代理，不直接打 R2）
export function fileUrl(key: string): string {
  return API_BASE + `/api/files?key=${encodeURIComponent(key)}`;
}
